module.exports = __webpack_public_path__ + "img/325.35be4132.png";